/**
 * Servicio de los slides del carrusel del home.
 *
 * SOLO LECTURA. La gestión (alta, edición, publicación, orden) se movió al CMS
 * aparte (Web.CMS.React).
 *
 * ⚠️ TODO: el backend real todavía NO implementa los endpoints de slides
 * (`/api/Slides...` no existe; hoy solo tiene `/api/Noticias`). Por eso este
 * servicio ignora `VITE_API_BASE_URL` A PROPÓSITO y sirve siempre los slides
 * por defecto del código (`defaultHeroSlides`), aunque el API de noticias esté
 * activo. Si se llama al backend antes de que tenga slides, la petición falla
 * (404) y el hero del home desaparece por completo (`useAsyncData` cae al
 * valor inicial, que quedaría vacío).
 *
 * Cuando el backend tenga los endpoints de slides: volver a decidir por
 * `isApiEnabled()` aquí, tal y como hace `newsService.ts` con las noticias.
 */

import { defaultHeroSlides, type HeroSlide } from '../data/heroSlides';

const memoriaPublicados = (): HeroSlide[] =>
  [...defaultHeroSlides]
    .filter((slide) => slide.status === 'published')
    .sort((a, b) => a.order - b.order);

/** Slides para el primer render, sin esperar al servicio: siempre los del código. */
export function getInitialHeroSlides(): HeroSlide[] {
  return memoriaPublicados();
}

/**
 * Solo los publicados, ordenados. Para el hero del home. Siempre los del código.
 *
 * Sin parámetros a propósito: `Hero.tsx` la llama con la firma que espera
 * `useAsyncData` (recibe un `AbortSignal`), y JavaScript ignora sin más los
 * argumentos de sobra en una llamada.
 */
export async function getPublishedHeroSlides(): Promise<HeroSlide[]> {
  return memoriaPublicados();
}
